// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"17416":"f5fb8f475a","66586":"a2720cdca2","76221":"72f1dca2da"}[chunkId] + ".css";
};